let articleItems = $('.about-software__item');
let articleCircles = $('.about-software__item-circle');
let activeLine = $('.about-software__line-active');

let $window = $(window);


function recalculateArticlePositions () {
    let windowScroll = $window.scrollTop();

    // Circles
    var currentI;
    for (let i = 0; i < articleCircles.length; i++) {
        let articleCirclesOffset = articleCircles.eq(i).offset().top;

        if (windowScroll + $('.header--settings-block').height() >= articleCirclesOffset) {

        } else {
            currentI = i;
            break;
        }
    }

    articleCircles.not(':eq(' + currentI + ')').removeClass('active');
    articleCircles.eq(currentI).addClass('active');

    // Titles & Images highlight
    articleItems.not(':eq(' + currentI + ')').removeClass('active');
    articleItems.eq(currentI).addClass('active');

    // Line
    if (currentI < articleCircles.length - 1) {
        let previousArticleOffset = currentI > 0 ? articleCircles.eq(currentI - 1).offset().top : 0;
        let previousArticleHeight = articleCircles.eq(currentI).offset().top - previousArticleOffset;
        let currentArticleHeight = articleCircles.eq(currentI + 1).offset().top - articleCircles.eq(currentI).offset().top;
        let previousArticlePathPercent = ($(window).scrollTop() + $('.header--settings-block').height() - previousArticleOffset) / previousArticleHeight;

        activeLine.height(articleCircles.eq(currentI).offset().top - articleCircles.eq(0).offset().top + currentArticleHeight * previousArticlePathPercent);
    } else {
        activeLine.height(articleCircles.last().offset().top - articleCircles.first().offset().top);
    }
}

recalculateArticlePositions();

//$window.scroll(recalculateArticlePositions);

document.addEventListener('scroll', function () {
    recalculateArticlePositions();
}, {passive: true});